import { useMutation, useQueryClient } from 'react-query';
import { deleteTopicService } from '../redux/services/topicService';
import HookTypes from '../redux/types/hooks';

type Mutation = {
  id: string;
};

export default function mutation() {
  const client = useQueryClient();

  return useMutation(
    async (mutation: Mutation) => {
      await deleteTopicService(mutation.id);
    },
    {
      onSuccess: async () => {
        await client.invalidateQueries([HookTypes.activity, HookTypes.post]);
      },
    }
  );
}
